import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/login';
import index1 from '@/components/index1';
import aboutUs from '@/components/aboutUs';
import businessServices from "../components/businessServices";
import login2 from '../components/loginAndReg/login2';
import reg from '../components/loginAndReg/reg';
import reBaiBai from "../components/reBaiBai/leBaiBaiIndex";
import reBusiness from "../components/reBaiBai/reBusiness";
import reBaiAbout from "../components/reBaiBai/reBaiAbout";
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    // {
    //   path: '/login',
    //   name:'login',
    //   component: login
    // },
    {
      path:'/',
      name:'index1',
      component: reBaiBai
      //口袋零钱首页
    },
    {
      path:'/aboutUs',
      name:'aboutUs',
      component: aboutUs
      //口袋零钱关于我们
    },
    {
      path: '/businessServices',
      name:'businessServices',
      component: businessServices
      //口袋零钱企业服务
    },
    {
      path: '/login2',
      name: 'login',
      component: login2
    },
    {
      path: '/reg',
      name:'reg',
      component: reg
    },
    {
      path: '/reBaiBai',
      name:'reBaiBai',
      component: reBaiBai
      //热摆摆首页
    },
    {
      path: '/reBusiness',
      name:'reBusiness',
      component: reBusiness
      //热摆摆企业服务
    },
    {
      path: '/reBaiAbout',
      name:'reBaiAbout',
      component: reBaiAbout
      //热摆摆关于我们
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js